/*eslint-disable*/
import api from '../'

class matrix {
  static getMatrixByRequest (params) {
    return api.axios.post('/matrixByRequest', params).then(response => response.data.matrix);
  }
}

export default matrix;
